export default "__VITE_ASSET__3f3cbded__"